import React from 'react';
import SemanticDatepicker from 'react-semantic-ui-datepickers';
import { Form } from 'semantic-ui-react';
import type { DropdownProps } from 'semantic-ui-react';
import { dropdownValue } from 'utils';

import type { AssignTaskFormProps } from '../../types';

import { AssignTaskFormGrid } from './assignTaskForm.styles';
import { STATUS_OPTIONS } from './constants';

/**
 * `Boolean(...)` on the vendor dropdown's `disabled`: `selectedNonFoodDeliveryTasks` is
 * optional, so `disableMultiSelect || selectedNonFoodDeliveryTasks` is
 * `boolean | undefined`, which Semantic's `disabled?: boolean` rejects under
 * `exactOptionalPropertyTypes`. It names the coercion the component already performs —
 * `disabled` is rendered through `useKeyOnly(val, key)` (`val && key`), where
 * `undefined` and `false` alike yield a falsy value that clsx drops.
 */
export const AssignTaskForm: React.FC<AssignTaskFormProps> = ({
  allOptions,
  disableMultiSelect,
  foodVendors,
  onSubmit,
  onOptionChange,
  practitionerList,
  selectedCareplanTasks,
  selectedNonFoodDeliveryTasks,
}) => {
  return (
    <Form style={{ width: '100%', marginTop: '5px' }} onSubmit={onSubmit}>
      <AssignTaskFormGrid>
        <Form.Dropdown
          floating
          selection
          scrolling
          search
          disabled={disableMultiSelect || selectedCareplanTasks}
          selectOnBlur={false}
          options={practitionerList}
          placeholder="Owner"
          {...dropdownValue(allOptions.assignee)}
          onChange={(_e: React.SyntheticEvent<HTMLElement>, value: DropdownProps) => {
            onOptionChange('assignee', value?.value);
          }}
          name="assignee"
        />
        <Form.Dropdown
          name="status"
          selection
          selectOnBlur={false}
          key="status"
          disabled={disableMultiSelect}
          placeholder="Status"
          {...dropdownValue(allOptions.status)}
          options={STATUS_OPTIONS}
          onChange={(_e: React.SyntheticEvent<HTMLElement>, value: DropdownProps) => {
            onOptionChange('status', value?.value);
          }}
        />
        <Form.Dropdown
          name="vendor"
          selection
          selectOnBlur={false}
          search
          key="vendor"
          disabled={Boolean(disableMultiSelect || selectedNonFoodDeliveryTasks)}
          placeholder="Vendor"
          {...dropdownValue(allOptions.vendor)}
          {...(foodVendors ? { options: foodVendors } : {})}
          onChange={(_e: React.SyntheticEvent<HTMLElement>, value: DropdownProps) => {
            onOptionChange('vendor', value?.value);
          }}
        />
        <Form.Field
          fullWidth
          control={SemanticDatepicker}
          placeholder="Due Date"
          disabled={disableMultiSelect}
          datePickerOnly
          clearable={false}
          value={allOptions.dueDate}
          onChange={(_e: React.SyntheticEvent<HTMLElement>, value: DropdownProps) => {
            onOptionChange('dueDate', value?.value);
          }}
        />
        <Form.Button primary content="Update" disabled={disableMultiSelect} />
      </AssignTaskFormGrid>
    </Form>
  );
};
